import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <se-po-address
      formControlName="address">
    </se-po-address>
    <div class="required-switch">
      <se-fe-form-control-label
        seFeDataLabel="Address required"
        seFeDataLabelFor="required-switch">
      </se-fe-form-control-label>
      <se-fe-switch
        seFeDataId="required-switch"
        seFeDataAriaLabel="Address required"
        (seFeChange)="toggleAddressValidation($event)">
      </se-fe-switch>
    </div>
    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit">
        Submit
      </se-fe-button>
    </div>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Component, OnInit } from '@angular/core'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

export class AddressExampleComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {}

  public ngOnInit(): void {
    this.form = this.fb.group({
      address: [null]
    })
  }

  public toggleAddressValidation(checked: boolean): void {
    if(checked) {
      this.form.get('address').setValidators(Validators.required)
      this.form.get('address').updateValueAndValidity()
    } else {
      this.form.get('address').clearValidators()
      this.form.get('address').updateValueAndValidity()
    }
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-address-example',
  template,
  styleUrls: ['../address-docs.component.scss'],
  standalone: false,
})
export class AddressExampleComponent extends SeFeDocsExampleComponent implements OnInit, OnDestroy {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      address: [null]
    })
  }

  public ngOnDestroy(): void {
    this.seFeToastService.events.next(undefined)
  }

  public toggleAddressValidation(checked: boolean): void {
    if(checked) {
      this.form.get('address').setValidators(Validators.required)
      this.form.get('address').updateValueAndValidity()
    } else {
      this.form.get('address').clearValidators()
      this.form.get('address').updateValueAndValidity()
    }
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
